// extracted by mini-css-extract-plugin
export default {"add-user-link-wrapper":"styles_add-user-link-wrapper__nmMxx"};